import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

//- material
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Popover from '@material-ui/core/Popover';
import NoteIcon from '@material-ui/icons/Note';

//- local
import DeliveriesContainer from '../../containers/logistics/StationDeliveries';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import { statusClassNames, formatDeliveries, PureRecordRow, isFiltered } from '../../libs/utility';
import ViewStationDeliveryDialog from '../../components/Dialogs/ViewStationDeliveryDialog';

import { getSharedStyles } from '../../themes';
const styles = (theme) => ({
	...statusClassNames,
	...getSharedStyles(theme),
	popOverPaper: {
		textAlign: 'left',
		boxSizing: 'border-box',
		padding: 20,
	},
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	addButton: {
		verticalAlign: 'middle',
		textDecoration: 'none',
		marginBottom: 10,
		borderRadius: 100,
	},
	formControl: {
		fontSize: 14,
		marginLeft: 20,
		flex: 1,
	},
	title: {
		display: 'flex',
		alignItems: 'flex-end',
	},
	comingSoon: {
		position: 'absolute',
		width: '100%',
		height: '100%',
		backgroundColor: 'rgba(140,140,140,.9)',
		fontSize: 50,
		color: 'white',
		zIndex: 200,
		paddingTop: 50,
		left: 0,
	},
	commentsContainer: {
		padding: 7,
		display: 'inline-block',
		fontSize: '90%',
	},
	commentDateTime: {
		fontSize: '80%',
		color: '#666',
	},
	popover: {
		pointerEvents: 'none',
	},
});

const columnStyle = { whiteSpace: 'nowrap' };
const columnData = [
	{
		id: 'stationDeliveryId',
		label: 'Delivery ID',
		padding: 'checkbox',
		style: { columnStyle },
	},

	{
		id: 'loadingNumbersDisplay',
		numeric: false,
		padding: 'checkbox',
		label: 'Loading #',
	},
	{
		id: 'stationSort',
		numeric: false,
		padding: 'checkbox',
		label: 'Station(s)',
	},
	{
		id: 'dateSort',
		numeric: false,
		padding: 'checkbox',
		label: 'Delivery Window',
	},
	{
		id: 'primaryDeliveryAmount',
		numeric: true,
		padding: 'checkbox',
		label: 'Volume(s)',
	},
	{
		id: 'carrierSearch',
		numeric: false,
		padding: 'checkbox',
		label: 'Carrier',
	},
	{
		id: 'statusDisplay',
		numeric: false,
		padding: 'checkbox',
		label: 'Status',
	},
	{
		id: 'internalNote',
		numeric: false,
		padding: 'checkbox',
		label: 'Internal Note',
	},
	{
		id: 'edit',
		numeric: false,
		padding: 'checkbox',
		label: 'Change',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

class Deliveries extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isViewDialogOpen: false,
			viewStationDelivery: undefined,
			order: 'desc',
			orderBy: 'stationDeliveryId',
			search: '',
			commentPopoverAnchor: undefined,
			popoverComment: '',
		};

		this.handleEdit = this.handleEdit.bind(this);
		this.handleRequestSort = this.handleRequestSort.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.handleRowClick = this.handleRowClick.bind(this);
		this.handleCloseViewDialog = this.handleCloseViewDialog.bind(this);
	}

	componentDidMount() {
		const { deliveries, stationMap, carrierMap } = this.props;
		if (!deliveries.length) {
			this.props.searchDeliveries();
		} else {
			const newState = {};
			newState.formattedDeliveries = formatDeliveries({
				deliveries,
				stationMap,
				carrierMap,
				handleRowClick: this.handleRowClick,
			});
			if (!_.isEmpty(_.keys(newState))) {
				this.setState(newState);
			}
		}
	}

	componentDidUpdate(prevProps) {
		const { deliveries, stationMap, carrierMap } = this.props;
		//const { order, orderBy, search } = this.state;
		const newState = {};

		//- Format the rows when you first get them or they change
		if (prevProps.deliveries !== deliveries) {
			newState.formattedDeliveries = formatDeliveries({
				deliveries,
				stationMap,
				carrierMap,
				handleRowClick: this.handleRowClick,
			});
		}

		if (!_.isEmpty(_.keys(newState))) {
			this.setState(newState);
		}
	}

	handleSearch(event) {
		this.setState({ search: event.target.value });
	}

	handleEdit(stationDeliveryId) {
		this.props.history.push(`/logistics/stationDelivery/update/${stationDeliveryId}`);
	}

	handleRequestSort(property) {
		const orderBy = property;
		let order = 'desc';
		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	}

	handleRowClick(stationDeliveryId) {
		const { deliveries } = this.props;
		const viewStationDelivery = _.find(deliveries, { stationDeliveryId });

		this.setState({
			viewStationDelivery,
			isViewDialogOpen: true,
		});
	}

	handleCloseViewDialog() {
		this.setState({
			isViewDialogOpen: false,
			viewStationDelivery: undefined,
		});
	}

	handleCommentPopoverOpen = (event, internalNote) => {
		this.setState({
			popoverComment: internalNote,
			commentPopoverAnchor: event.currentTarget,
		});
	};
	handleCommentPopoverClose = () => {
		this.setState({ commentPopoverAnchor: null });
	};

	render() {
		const {
			classes,
			//deliveries,
			authUser,
			stationMap,
			//carrierMap,
		} = this.props;

		const { order, orderBy, search, formattedDeliveries } = this.state;
		if (!formattedDeliveries || !authUser) {
			return <Paper>Fetching deliveries...</Paper>;
		}
		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);

		let data = formattedDeliveries.reduce((result, row) => {
			const { internalNote } = row;

			let commentDisplay;
			if (!internalNote) {
				commentDisplay = <div>-</div>;
			} else {
				commentDisplay = (
					<div
						style={{ display: 'inline-block', color: '#2196f3' }}
						onMouseEnter={(event) => {
							this.handleCommentPopoverOpen(event, internalNote);
						}}
						onMouseLeave={this.handleCommentPopoverClose}
					>
						<NoteIcon />
					</div>
				);
			}
			row.commentDisplay = commentDisplay;

			if (
				isFiltered({
					search,
					data: row,
					fields: [
						'stationDeliveryId',
						'primaryStationName',
						'secondaryStationName',
						'carrierSearch',
						'firstTerminalLoadingNumber',
						'firstTerminalSecondaryLoadingNumber',
						'secondTerminalLoadingNumber',
						'secondTerminalSecondaryLoadingNumber',
					],
				})
			) {
				return result;
			}

			result.push(row);
			return result;
		}, []);

		/*
		let data = formatDeliveries({
			deliveries,
			stationMap,
			carrierMap,
			handleRowClick : this.handleRowClick,
			search,
		});
		*/

		data =
			order === 'desc'
				? data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
				: data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					{/*<div className={classes.comingSoon}>COMING SOON</div>*/}
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>Deliveries</span>
								<TextField
									className={classes.formControl}
									value={this.state.search}
									onChange={(event) => this.handleSearch(event)}
									label="Type to search"
									fullWidth
								/>
							</Typography>
						</Grid>
						{canMakeUpdates && (
							<Grid item xs={4} style={{ textAlign: 'right' }}>
								<Link to="/logistics/stationDelivery/add" style={{ textDecoration: 'none' }}>
									<Button variant="contained" color="primary" className={classes.addButton}>
										ADD DELIVERY
									</Button>
								</Link>
							</Grid>
						)}
					</Grid>

					<Paper className={classes.paper}>
						<Table stickyHeader size="small" className={classes.table}>
							<EnhancedTableHead
								columnData={columnData}
								order={order}
								orderBy={orderBy}
								onRequestSort={this.handleRequestSort}
							/>
							<TableBody>
								{data.map((row) => {
									let loadingNumberDisplay = '-';
									if (!_.isEmpty(row.loadingNumbers)) {
										loadingNumberDisplay = row.loadingNumbers.join(', ');
									}

									return (
										<PureRecordRow hover className={classes.row} key={row.stationDeliveryId}>
											<TableCell>
												<div>{row.stationDeliveryId}</div>
												<div style={{ fontSize: '10px', color: '#777' }}>
													FUEL: {row.primaryProductType}
												</div>
											</TableCell>
											<TableCell onClick={row.rowClick}>{loadingNumberDisplay}</TableCell>
											<TableCell onClick={row.rowClick}>{row.stations}</TableCell>
											<TableCell onClick={row.rowClick}>{row.dateTime}</TableCell>
											<TableCell onClick={row.rowClick} align="right">
												{row.volumes}
											</TableCell>
											<TableCell onClick={row.rowClick}>{row.carrierName}</TableCell>
											<TableCell onClick={row.rowClick} className={classes[row.statusClassName]}>
												{row.statusDisplay}
											</TableCell>
											<TableCell>{row.commentDisplay}</TableCell>

											{canMakeUpdates && (
												<TableCell style={{ whiteSpace: 'nowrap' }}>
													<Button
														className={classes.button}
														onClick={() => this.handleEdit(row.stationDeliveryId)}
													>
														Change
													</Button>
												</TableCell>
											)}
										</PureRecordRow>
									);
								})}
							</TableBody>
						</Table>

						<ViewStationDeliveryDialog
							onClose={this.handleCloseViewDialog}
							stationDelivery={this.state.viewStationDelivery}
							stationMap={stationMap}
							authUser={authUser}
							open={this.state.isViewDialogOpen}
							history={this.props.history}
						/>

						<Popover
							id="comment-popover"
							className={classes.popover}
							classes={{ paper: classes.popOverPaper }}
							open={!!this.state.commentPopoverAnchor}
							anchorEl={this.state.commentPopoverAnchor}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'left',
							}}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'left',
							}}
							onClose={this.state.handleCommentPopoverClose}
							disableRestoreFocus
						>
							<div className={classes.commentsContainer}>
								{!!this.state.popoverComment && <div>{this.state.popoverComment}</div>}
							</div>
						</Popover>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

Deliveries.propTypes = {
	classes: PropTypes.object.isRequired,
	searchDeliveries: PropTypes.func.isRequired,
	deliveries: PropTypes.array,

	stationMap: PropTypes.object,
	supplierMap: PropTypes.object,
	carrierMap: PropTypes.object,
	terminalMap: PropTypes.object,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), DeliveriesContainer])(Deliveries);
